import React, { useContext } from 'react'
import { TableCell } from '@material-ui/core'
import { DesignContext } from 'contexts/DesignContext'
import { useTimeFormat } from 'contexts/TimeFormatContext'
import { getEditComponent, getRenderColumn } from '../action/Column'
import './style.css'
import objectPath from 'object-path'

const RenderRow = (props) => {
  const designContext = useContext(DesignContext)
  const { elementAction } = designContext
  let { uischema, tableColumn, rowData, onEditRow } = props
  let hasEnable = objectPath.has(elementAction, ['isEnable', uischema.key])
  let isEnable = hasEnable
    ? objectPath.get(elementAction, ['isEnable', uischema.key])
    : true
  const isReadOnly = !isEnable
  const { formatDate, formatTime, formatDateTime } = useTimeFormat()
  const style = {
    padding: uischema.rowPadding,
  }

  const createColumnActionProps = (column) => {
    const defaultProp = {
      ...props,
      uischema,
      column,
      designContext,
      focus: props.focus,
      tableRef: props.tableRef,
      formData: designContext?.jsonForm?.formData,
    }
    const stateParent = {
      ...props,
      tableData: props.tableData || [],
      setTableData: props.setTableData,
      focus: props.focus,
      setFocus: props.setFocus || (() => {}),
      columnRequire: props.columnRequire || [],
    }
    const dateTimeProp = { formatDate, formatTime, formatDateTime }
    const actionProp = {
      ...props,
      onOpenModalTable: props.onOpenModalTable || (() => {}),
    }

    return { defaultProp, dateTimeProp, stateParent, actionProp }
  }

  const renderColumnValue = (column) => {
    const columnProps = createColumnActionProps(column)
    const editComponent = getEditComponent(columnProps, true)
    if (isReadOnly) {
      const render = getRenderColumn(columnProps, isReadOnly)
      return render?.(rowData)
    }
    return editComponent?.({ rowData, onRowDataChange: onEditRow })
  }

  return tableColumn.map((column) => {
    let { field, textAlign = 'left', minWidth, maxWidth } = column
    return (
      <TableCell
        key={field}
        style={{ ...style, minWidth, maxWidth }}
        align={textAlign}
      >
        {renderColumnValue(column)}
      </TableCell>
    )
  })
}

export default RenderRow
